import React from 'react';
import FontAwesome from 'react-fontawesome';
import Router from 'react-router';

import StaffPageItem from 'components/pages/staff/StaffPageItem';
import { BREAK_POINT } from 'constants/responsive';
import { PagesApi, UsersApi } from 'providers/api';
import Log from 'providers/log';

import { Page } from 'types/drupal/PageNode';
import { StaffPageUser } from 'types/drupal/User';

import './StaffPage.sass';

interface Props {
    match: Router.match<{}>;
}

interface State {
    pageLoaded: boolean;
    page: Page;
    usersLoaded: boolean;
    users: StaffPageUser[];
}

class StaffPage extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            page: null,
            pageLoaded: false,
            users: null,
            usersLoaded: false
        };
    }

    public componentDidMount() {
        PagesApi.getPage('gruhn-guitars-staff').then((page: Page) => {
            this.setState({ page, pageLoaded: true });
        }).catch(reason => Log.error(reason));
        UsersApi.getStaff().then((users: StaffPageUser[]) => {
            this.setState({ users, usersLoaded: true });
        }).catch(reason => Log.error(reason));
    }

    public render() {
        const { pageLoaded, page, usersLoaded, users } = this.state;
        if (!pageLoaded) return (<FontAwesome className="loading-spinner" name="spinner" size="3x" spin />);
        return (
            <div className="row StaffPage-container">
                <div className="offset-md-1 col-md-10 StaffPage-col">
                    <div className="StaffPage-description" dangerouslySetInnerHTML={{ __html: page.body.value }} />
                    <div className="StaffPageItems-title">Staff Profiles</div>
                    {!usersLoaded
                    ? (<FontAwesome className="loading-spinner" name="spinner" size="3x" spin />)
                    : (
                        users.map((user: StaffPageUser) => {
                            const { name, title, picture, alias: userUri } = user;
                            const imgUrl = picture.url;
                            return(
                                <div className="col-md-3 col-6" key={user.uid}>
                                    <StaffPageItem name={name} title={title} imgUrl={imgUrl} userUri={userUri} />
                                </div>
                            );
                        }).reduce<JSX.Element[][]>((prev: JSX.Element[][], cur: JSX.Element, index: number) => {
                            if (index % (window.innerWidth < BREAK_POINT ? 2 : 4) === 0) prev.push(Array());
                            prev[prev.length - 1].push(cur);
                            return prev;
                        },                         []).map((subElms: JSX.Element[]) => {
                            return <div className="row StaffPageItems-row" key={subElms.map(s => s.key).join()}>{subElms}</div>;
                        })
                    )}
                </div>
            </div>
        );
    }
}

export default StaffPage;



// WEBPACK FOOTER //
// ./src/components/pages/staff/StaffPage.tsx